import React, { useState } from 'react';
import { Button, Form, DatePicker, notification } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import fileDownload from 'js-file-download';
import axios from '../../../helpers/Axios';

const { RangePicker } = DatePicker;
const dateFormat = 'MM/DD/YYYY';
const BRAND = '#0f8269';

const ExceptionalReportCard = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [loadingReport, setLoadingReport] = useState(false);
  const [form] = Form.useForm();

  const disabledDate = (current) => current && current > dayjs().endOf('day');

  const filingHeaders = {
    headers: {
      'X-Gravitee-Api-Key': process.env.REACT_APP_GRAVITEE_API_KEY_FILING,
    },
  };

  const handleGenerateReport = async () => {
    const [startDate, endDate] = dateRange;
    if (!startDate || !endDate) {
      notification.warning({ message: 'Please select a valid date range.' });
      return;
    }
    setLoadingReport(true);
    try {
      const response = await axios.get(
        `https://api.fortisph.space/gateway/filing/reports/companies/exceptional/?start=${startDate.format('YYYY-MM-DD')}&end=${endDate.format('YYYY-MM-DD')}`,
        filingHeaders,
        { responseType: 'blob' },
      );
      fileDownload(response.data, `Index_Report_${dayjs().format('YYYYMMDD_HHmm')}.xlsx`);
      notification.success({ message: 'Index report generated successfully!' });
      form.resetFields();
      setDateRange([null, null]);
    } catch {
      notification.error({ message: 'Failed to generate index report.' });
    } finally {
      setLoadingReport(false);
    }
  };

  return (
    <Form layout="vertical" form={form} onFinish={handleGenerateReport} size="small">

      <Form.Item
        name="date_range"
        label="Date Range"
        rules={[{ required: true, message: 'Please select a date range' }]}
        style={{ marginBottom: 18 }}
      >
        <RangePicker
          style={{ width: '100%', display: 'flex' }}
          onChange={(dates) => setDateRange(dates)}
          disabledDate={disabledDate}
          format={dateFormat}
        />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        block
        loading={loadingReport}
        icon={<FileExcelOutlined />}
        style={{ background: BRAND, borderColor: BRAND, height: 36, fontWeight: 600 }}
      >
        Generate Report
      </Button>

    </Form>
  );
};

export default ExceptionalReportCard;
